import { getInitData } from "./initData.js";

export async function apiFetch(input, init = {}) {
  const headers = new Headers(init.headers || {});
  const initData = getInitData();
  if (initData) headers.set("X-Telegram-Init-Data", initData);
  return await fetch(input, { ...init, headers });
}

/** Разбор тела ответа FastAPI: { "detail": "..." | [...] } → сообщение + status на объекте Error */
function errorFromTextAndStatus(text, status) {
  let message = (text && String(text).trim()) || `HTTP ${status}`;
  if (
    status === 413 ||
    /413\s+Request Entity Too Large/i.test(message) ||
    /<title>\s*413\s+Request Entity Too Large/i.test(message)
  ) {
    message =
      "Файл слишком большой для веб‑сервера (Nginx). Нужно увеличить client_max_body_size (см. nginx-upload-snippet.conf в репозитории).";
  }
  try {
    const j = JSON.parse(text);
    if (j?.detail != null) {
      const d = j.detail;
      message = Array.isArray(d)
        ? d
            .map((x) =>
              typeof x === "object" && x != null && x.msg != null ? String(x.msg) : String(x)
            )
            .join("; ")
        : String(d);
    }
  } catch {
    // оставляем message как текст ответа
  }
  const err = new Error(message);
  err.status = status;
  return err;
}

/** Для ручного разбора после apiFetch (например send-media с FormData). */
export async function errorFromResponse(res) {
  const t = await res.text();
  return errorFromTextAndStatus(t, res.status);
}

export async function apiJson(input, init = {}) {
  const res = await apiFetch(input, init);
  if (!res.ok) {
    throw await errorFromResponse(res);
  }
  return await res.json();
}
